import { type DetailedPublicTemplateResponse } from '@/types/global-types';
import { isJsonFormTemplate } from '@heidi/templates/data';

// TODO: drop this widening once the template-gallery schema carries json_source
// (`pnpm run schema:dev`).
type GalleryContentWithJsonSource = DetailedPublicTemplateResponse['template_content'] & {
  json_source?: string | null;
};

/**
 * JSON source the community page may preview or fill.
 *
 * Gated by `release-growth-enable-json-form`. An S3 PDF wins when both are
 * present, matching `communityXmlSource`.
 */
export const communityJsonSource = (
  template: DetailedPublicTemplateResponse,
  isJsonFormEnabled: boolean
): string | null => {
  if (!isJsonFormEnabled) return null;

  const content: GalleryContentWithJsonSource = template.template_content;
  if (content.s3_object_key) return null;
  if (
    !isJsonFormTemplate({
      template_category: template.template_category,
      form_format: content.form_format,
    })
  ) {
    return null;
  }

  return content.json_source ?? null;
};
